import { Directions } from '@surgetech-eu/core'

export const DIRECTIONS: Directions = {
    login: ['account', 'signin']
}
